import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { FluidOwaSource, isFluidEnabledForSource } from 'owa-fluid-validations';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    initCollabSpaceViewState,
    resetCollabSpaceStore,
    removeViewStateFromCollection,
} from '../mutators/collabSpaceMutators';
import CollabSpaceRenderer from './CollabSpaceRenderer';
import { parseCollabSpace } from '../utils/parseCollabSpace';
import CollabSpaceCompose from './CollabSpaceCompose';
import { getViewStateById } from '../selectors/collabSpaceSelectors';
import { initializeStore } from '../mutators/initializeStore';

export interface CollabSpaceProps {
    event: CalendarEvent;
    fluidOwaSource: FluidOwaSource;
    viewStateId: string;
}

export default observer(function CollabSpace(props: CollabSpaceProps) {
    const { event, fluidOwaSource, viewStateId } = props;

    if (!getViewStateById(viewStateId)) {
        initializeStore(viewStateId);
    }

    const { collabAllowed } = getViewStateById(viewStateId);

    React.useEffect(() => {
        if (event.CollabSpace) {
            const collabSpaceParsed = parseCollabSpace(event.CollabSpace);
            initCollabSpaceViewState(
                collabSpaceParsed.shareLink,
                collabSpaceParsed.collabAllowed,
                collabSpaceParsed.isShared,
                viewStateId
            );
        }
    }, [event.CollabSpace]);

    React.useEffect(() => {
        return () => {
            resetCollabSpaceStore(viewStateId);
            // Since Compose can open SA and come back we need to preserve the store.
            // FullComposeForm takes care of removal for this scenario.
            if (fluidOwaSource != FluidOwaSource.CalendarCompose) {
                removeViewStateFromCollection(viewStateId);
            }
        };
    }, []);

    if (!isFluidEnabledForSource(fluidOwaSource)) {
        return null;
    }

    if (fluidOwaSource === FluidOwaSource.CalendarCompose) {
        return (
            <CollabSpaceCompose
                event={event}
                fluidOwaSource={fluidOwaSource}
                viewStateId={viewStateId}
            />
        );
    } else {
        return (
            collabAllowed && (
                <CollabSpaceRenderer
                    event={event}
                    fluidOwaSource={fluidOwaSource}
                    viewStateId={viewStateId}
                />
            )
        );
    }
});
